module.exports = __webpack_public_path__ + "static/media/brief-hoofd.fc5503e2.jpg";